import React from 'react';
import PropTypes from 'prop-types';
import { createVariants } from './_variants';

const inputClasses = createVariants({
  base:
    'w-full bg-succession-bg-primary text-succession-text-primary placeholder-succession-text-muted border border-succession-border hover:border-succession-border-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-succession-focus-ring rounded-md transition-theme duration-theme',
  variants: {
    primary: '',
    // Subtle input for dense UIs
    subtle: 'bg-succession-bg-secondary',
    // Destructive style hint (border emphasis); for error states prefer aria-invalid + message
    danger: 'border-succession-error',
  },
  sizes: {
    sm: 'text-sm px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2',
  },
  defaultVariant: 'primary',
  defaultSize: 'md',
});

const Input = React.forwardRef(function Input(
  { className, variant = 'primary', size = 'md', type = 'text', ...rest },
  ref,
) {
  const classes = inputClasses({ variant, size, className, disabled: rest.disabled });
  return <input ref={ref} className={classes} type={type} {...rest} />;
});

Input.propTypes = {
  variant: PropTypes.oneOf(['primary', 'subtle', 'danger']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
  type: PropTypes.string,
};

export default Input;


